import script from "./LinkBottomSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkBottomSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./LinkBottomSkeleton.vue?vue&type=style&index=0&id=d65d0eea&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d65d0eea"]])

export default __exports__